import { convertToPixels } from "client/utils/pixels/convertToPixels";
import { PreviewImage } from "store/types/previewImage";
import { Dimension } from "store/types/resizeSettings";
import { Unit } from "store/types/unit";

export const validateResizeDimension = (
    image: {
        original: Omit<PreviewImage["original"], "size">;
        preview: Omit<PreviewImage["preview"], "size">;
    },
    dimensionType: Dimension,
    unit: Unit,
    percentage: number = 100,
    MAX_RESIZE_SIZE_IN_PX: number,
    dpi?: number,
) => {
    if (dimensionType === "percentage") {
        const { width, height } = image.original;

        const percentAppliedWidth = (width * percentage) / 100;
        const percentAppliedHeight = (height * percentage) / 1000;

        if (percentAppliedWidth > MAX_RESIZE_SIZE_IN_PX || percentAppliedHeight > MAX_RESIZE_SIZE_IN_PX) {
            return false;
        }

        return true;
    }

    const { width, height } = image.preview;
    const widthInPixels = convertToPixels(width, unit, dpi);
    const heightInPixels = convertToPixels(height, unit, dpi);

    if (
        widthInPixels <= 0 ||
        heightInPixels <= 0 ||
        widthInPixels > MAX_RESIZE_SIZE_IN_PX ||
        heightInPixels > MAX_RESIZE_SIZE_IN_PX
    ) {
        return false;
    }
    return true;
};
